import { useEffect } from "react";
import useApis from "./useAPI";
import { useAuth } from "../components/AuthContext/AuthContext";
import {
  createtrainingphlebotomisturl,
  resettrainingphlebotomisturl,
} from "../utils/constants";
import { CheckCircleFill, XCircleFill } from "react-bootstrap-icons";

const useTraining = () => {
  const auth = useAuth();

  const { callApi, resultPost, serverError } = useApis();

  const toggleTrainingStart = async () => {
    await callApi(
      null,
      createtrainingphlebotomisturl,
      "POST",
      {
        Authorization: `Bearer ${
          localStorage.getItem("access_token") || auth?.accessToken
        }`,
        "Content-Type": "application/json",
      }
    );
  };

  const toggleTrainingStop = async () => {
    await callApi(
      null,
      resettrainingphlebotomisturl,
      "POST",
      {
        Authorization: `Bearer ${
          localStorage.getItem("access_token") || auth?.accessToken
        }`,
        "Content-Type": "application/json",
      }
    );
  };

  useEffect(() => {
    if (resultPost) {
      auth?.showToast(
        "Success",
        resultPost.message,
        undefined,
        {
          icon: <CheckCircleFill />,
          className: auth?.featureFlag && "vh-toaster",
        }
      );
    }

    if (serverError) {
      auth?.showToast(
        "Error",
        serverError,
        "../assets/mhc.png",
        {
          icon: <XCircleFill />,
        }
      );
    }
  }, [resultPost, serverError]);

  return {
    toggleTrainingStart,
    toggleTrainingStop,
  };
};

export default useTraining;